export const pacienteFormStyles = `
  .paciente-form .form-control {
    border-radius: 6px;
    min-height: 34px;
    padding-top: 0.32rem;
    padding-bottom: 0.32rem;
    font-size: 0.9rem;
  }
  .paciente-form .MuiInputBase-root {
    border-radius: 6px;
    min-height: 34px;
    font-size: 0.9rem;
    padding-top: 0;
    padding-bottom: 0;
    align-items: center;
  }
  .paciente-form .MuiInputBase-input {
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    box-sizing: border-box;
    height: auto;
  }
  .paciente-form .paciente-form-col-data-nasc .MuiInputBase-root {
    width: 100%;
  }
  .paciente-form .paciente-form-col-data-nasc .MuiInputAdornment-root .MuiIconButton-root {
    padding: 4px;
  }
  .paciente-form textarea.form-control {
    min-height: 72px;
  }
  .paciente-form .form-label {
    font-weight: 500;
    font-size: 0.8125rem;
    color: #6c757d;
    margin-bottom: 0.28rem;
  }
  .paciente-form .form-group {
    margin-bottom: 0.65rem;
  }
  .paciente-form .form-row > .col,
  .paciente-form .form-row > [class*="col-"] {
    padding-left: 6px;
    padding-right: 6px;
  }
  .paciente-form .form-row {
    margin-left: -6px;
    margin-right: -6px;
  }
  @media (max-width: 767.98px) {
    .paciente-form .MuiPickersStaticWrapper-staticWrapperRoot {
      max-height: 220px;
      overflow-y: auto;
    }
  }
  .paciente-form-section-title {
    font-size: 0.9375rem;
    font-weight: 600;
    color: #495057;
    text-transform: none;
    letter-spacing: normal;
    padding-bottom: 0.35rem;
    margin-bottom: 0.65rem;
    margin-top: 0;
    border-bottom: 1px solid #e9ecef;
  }
  .paciente-form-actions {
    gap: 0.35rem;
  }
  @media (max-width: 767.98px) {
    .paciente-form .paciente-form-btn-icon {
      width: 100%;
    }
  }
  .paciente-form .paciente-email-card,
  .paciente-form .paciente-telefone-card,
  .paciente-form .paciente-dependente-card {
    border-radius: 8px;
    border-color: #e9ecef !important;
    background: #fff;
    margin-bottom: 0.75rem !important;
    box-shadow: none !important;
  }
  .paciente-form .paciente-form-list-wrap {
    background: #fafbfc;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 0.35rem 0.5rem;
  }
  .paciente-form .paciente-form-list-table thead th {
    border-bottom: 1px solid #e9ecef !important;
    font-weight: 600;
  }
  .paciente-form .paciente-form-list-table tbody td {
    vertical-align: middle;
  }
  .paciente-form-item-modal .modal-content {
    border-radius: 12px;
  }
  .paciente-form-item-modal__dialog--compact {
    max-width: 380px !important;
    width: calc(100vw - 2rem);
    margin: 1rem auto;
  }
  .paciente-form-item-modal__dialog--dependente {
    max-width: 520px !important;
    width: calc(100vw - 2rem);
    margin: 1rem auto;
  }
  .paciente-form-item-modal .modal-dialog.paciente-form-item-modal__dialog--compact .modal-body,
  .paciente-form-item-modal .modal-dialog.paciente-form-item-modal__dialog--dependente .modal-body {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .paciente-form-item-modal .modal-dialog.paciente-form-item-modal__dialog--compact .modal-header,
  .paciente-form-item-modal .modal-dialog.paciente-form-item-modal__dialog--dependente .modal-header {
    padding: 0.65rem 1rem;
  }
  .paciente-form-item-modal .modal-dialog.paciente-form-item-modal__dialog--compact .modal-footer,
  .paciente-form-item-modal .modal-dialog.paciente-form-item-modal__dialog--dependente .modal-footer {
    padding: 0.5rem 1rem 0.85rem;
  }
  .paciente-form-telefone-modal .paciente-form-telefone-modal-body .form-label {
    font-size: 0.875rem;
  }
  .paciente-form-telefone-modal .paciente-form-telefone-modal-body .form-check-label {
    font-size: 0.9rem;
  }
  .paciente-form .paciente-email-card .card-body,
  .paciente-form .paciente-telefone-card .card-body {
    padding: 0.65rem 0.75rem;
  }
  .paciente-form .paciente-dependente-card .card-body {
    padding: 0.65rem 0.75rem;
  }
  .paciente-form-fab {
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    z-index: 1035;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    gap: 0.35rem;
  }
  .paciente-form-fab .paciente-form-fab-btn {
    width: 2.4rem;
    height: 2.4rem;
    padding: 0;
    border-radius: 50% !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 10px rgba(15, 23, 42, 0.14);
  }
  .paciente-form-fab .paciente-form-fab-btn svg {
    font-size: 0.95rem;
  }
  .paciente-form-fab .paciente-form-fab-btn--primary {
    box-shadow: 0 2px 10px rgba(8, 129, 199, 0.35);
  }
  .paciente-form-fab .paciente-form-fab-btn--light {
    background-color: #fff !important;
    border-color: #e2e8f0 !important;
    color: #64748b;
  }
  .paciente-form-fab .paciente-form-fab-btn--light:hover,
  .paciente-form-fab .paciente-form-fab-btn--light:focus {
    background-color: #fff !important;
    border-color: #0881c7 !important;
    color: #0881c7;
    box-shadow: 0 2px 10px rgba(8, 129, 199, 0.2);
  }
  .paciente-form-fab .paciente-form-fab-btn--light:hover svg,
  .paciente-form-fab .paciente-form-fab-btn--light:focus svg {
    color: #0881c7;
  }
  .paciente-form-app-bar {
    z-index: 1030;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    border-top: 1px solid #e2e8f0;
    box-shadow: 0 -6px 24px rgba(15, 23, 42, 0.07);
    padding-bottom: max(0.35rem, env(safe-area-inset-bottom, 0px));
  }
  .paciente-form-app-bar__inner {
    display: flex;
    align-items: stretch;
    min-height: 58px;
    overflow: hidden;
    border-radius: 0;
  }
  .paciente-form-app-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.15rem;
    padding: 0.45rem 0.5rem 0.55rem;
    margin: 0;
    border: 0;
    background: transparent;
    font-size: 0.68rem;
    font-weight: 600;
    color: #475569;
    letter-spacing: 0.02em;
    line-height: 1.15;
    -webkit-tap-highlight-color: transparent;
  }
  .paciente-form-app-btn:active {
    background: rgba(8, 129, 199, 0.08);
  }
  .paciente-form-app-btn svg {
    font-size: 1.4rem;
    margin-bottom: 1px;
  }
  .paciente-form-app-btn--primary {
    color: #06659e;
  }
  .paciente-form-app-btn--primary svg {
    color: #0881c7;
  }
  .paciente-form-app-bar__vsep {
    flex-shrink: 0;
    width: 1px;
    align-self: stretch;
    margin: 0.45rem 0;
    border: 0;
    background: linear-gradient(
      180deg,
      rgba(241, 245, 249, 0) 0%,
      rgba(203, 213, 225, 0.35) 22%,
      rgba(203, 213, 225, 0.35) 78%,
      rgba(241, 245, 249, 0) 100%
    );
    box-shadow: none;
  }
  .paciente-form-mobile-drawer-root {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1040;
    pointer-events: none;
  }
  .paciente-form-mobile-drawer-root--open {
    pointer-events: auto;
  }
  .paciente-form-mobile-drawer-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    background: rgba(15, 23, 42, 0.48);
    opacity: 0;
    transition: opacity 0.32s ease;
    -webkit-tap-highlight-color: transparent;
  }
  .paciente-form-mobile-drawer-root--open .paciente-form-mobile-drawer-backdrop {
    opacity: 1;
  }
  .paciente-form-mobile-drawer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: min(100%, 300px);
    max-width: 100vw;
    background: #fff;
    z-index: 1;
    display: flex;
    flex-direction: column;
    box-shadow: -8px 0 32px rgba(15, 23, 42, 0.12);
    transform: translate3d(100%, 0, 0);
    transition: transform 0.34s cubic-bezier(0.32, 0.72, 0, 1);
    will-change: transform;
    backface-visibility: hidden;
  }
  .paciente-form-mobile-drawer-root--open .paciente-form-mobile-drawer {
    transform: translate3d(0, 0, 0);
  }
  @media (prefers-reduced-motion: reduce) {
    .paciente-form-mobile-drawer-backdrop {
      transition-duration: 0.01ms;
    }
    .paciente-form-mobile-drawer {
      transition-duration: 0.01ms;
    }
  }
  .paciente-form-mobile-drawer__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1rem 0.75rem;
    border-bottom: 1px solid #f1f5f9;
  }
  .paciente-form-mobile-drawer__title {
    font-size: 1.05rem;
    font-weight: 600;
    color: #334155;
    margin: 0;
  }
  .paciente-form-mobile-drawer__body {
    flex: 1;
    overflow-y: auto;
    padding: 0.5rem 0;
    -webkit-overflow-scrolling: touch;
  }
  .paciente-form-mobile-drawer__item {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: left;
    padding: 0.85rem 1.25rem;
    border: 0;
    border-bottom: 1px solid #f1f5f9;
    background: #fff;
    font-size: 0.95rem;
    color: #334155;
  }
  .paciente-form-mobile-drawer__item:active {
    background: #f8fafc;
  }
  .paciente-form-mobile-drawer__item svg {
    width: 1.15rem;
    margin-right: 0.75rem;
    color: #64748b;
  }
  @media (max-width: 767.98px) {
    .paciente-form.paciente-form--fab-mobile-pad {
      padding-bottom: 6.5rem;
    }
  }
  @media (min-width: 768px) {
    .paciente-form.paciente-form--fab-mobile-pad {
      padding-bottom: 0.5rem;
    }
  }
  .paciente-form .input-group-text {
    font-size: 0.85rem;
    padding: 0.25rem 0.5rem;
  }
  .paciente-form .form-label.small,
  .paciente-form label.small {
    font-weight: 400;
    color: #6c757d;
  }
`
